import { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import StorefrontFiltersManager from '@/components/dashboard/StorefrontFiltersManager';
import StorefrontCategoryManager from '@/components/dashboard/StorefrontCategoryManager';

export function StorefrontSettings() {
  const [activeTab, setActiveTab] = useState('filters');

  return (
    <div className="space-y-6">
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="filters">Filtros</TabsTrigger>
          <TabsTrigger value="organization">Organização</TabsTrigger>
        </TabsList>
        
        <TabsContent value="filters" className="mt-6">
          <Card>
            <CardHeader>
              <CardTitle>Configurações de Filtros</CardTitle>
              <CardDescription>
                Configure quais filtros serão exibidos na sua vitrine de imóveis
              </CardDescription>
            </CardHeader>
            <CardContent>
              <StorefrontFiltersManager />
            </CardContent>
          </Card>
        </TabsContent>
        
        <TabsContent value="organization" className="mt-6">
          <Card>
            <CardHeader>
              <CardTitle>Organização por Categorias</CardTitle>
              <CardDescription>
                Configure a ordem e quantidade de produtos por categoria na sua vitrine
              </CardDescription>
            </CardHeader>
            <CardContent>
              <StorefrontCategoryManager />
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
}